import { create } from 'zustand';

type Mode = 'light' | 'dark';

interface ThemeState {
  mode: Mode;
  toggle: () => void;
}

export const useTheme = create<ThemeState>((set) => ({
  mode: 'light',
  toggle: () => set((s) => ({ mode: s.mode === 'light' ? 'dark' : 'light' })),
}));
